<app-usuario-logado-info>
  <ng-template #body let-usuario>
    <app-dropdown #dropdown class="left-0 w-full">
      <button
        appButton
        asTrigger
        class="flex h-10 max-w-60 flex-row items-center gap-2 rounded-lg border border-gray-200 bg-transparent pl-1.5 pr-2.5 transition-colors hover:bg-gray-200/60"
        variant="link">
        <app-avatar-usuario [usuario]="usuario" class="h-8 w-8 rounded-full text-sm font-medium" variant="brand" />
        <span class="line-clamp-1 text-xs text-[#374151]">{{ usuario.nomeCompleto.toUpperCase() }}</span>
        <app-icon class="flex items-center text-content-tertiary" name="chevron_down" size="1.1em" />
      </button>
      <ul>
        <li>
          <button
            appButton
            class="flex w-full items-center justify-start rounded-md whitespace-nowrap text-xs font-normal text-[#374151] transition-colors hover:bg-[#f5f5f5]"
            variant="link"
            (click)="abrirMeuPerfil()">
            <div class="flex items-center gap-2.5">
              <app-icon class="flex items-center" name="user_account" />
              <span>Meu perfil</span>
            </div>
          </button>
        </li>
        <li>
          <button
            appButton
            class="flex w-full items-center justify-start rounded-md whitespace-nowrap text-xs font-normal text-[#374151] transition-colors hover:bg-[#f5f5f5]"
            variant="link"
            (click)="toggleModalTrocarSenha()">
            <div class="flex items-center gap-2.5">
              <app-icon class="flex items-center" name="reset_password" />
              <span>Alterar senha</span>
            </div>
          </button>
        </li>
        <li>
          <button
            appButton
            class="flex w-full items-center justify-start rounded-md whitespace-nowrap text-xs font-normal text-[#374151] transition-colors hover:bg-[#f5f5f5]"
            variant="link"
            (click)="verNovidades()">
            <div class="flex items-center gap-2.5">
              <app-icon class="flex items-center" name="checkmark_badge_01" />
              <span>Novidades da versão</span>
            </div>
          </button>
        </li>
        <li>
          <button
            (click)="deslogar()"
            appButton
            class="flex w-full items-center justify-start rounded-md whitespace-nowrap text-xs font-normal text-[#374151] transition-colors hover:bg-[#f5f5f5]"
            type="button"
            variant="link">
            <div class="flex items-center gap-2.5">
              <app-icon class="flex items-center" name="logout_04" />
              <span>Sair do sistema</span>
            </div>
          </button>
        </li>
      </ul>
    </app-dropdown>
  </ng-template>
</app-usuario-logado-info>
